import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import {
  convertDateWithValidation,
  validate,
} from "../../helper/losDataHelper";
import { Visibility } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { CommonInformationDialogReduerAction } from "../../../Store/dialog/CommonInformationDialogReduer";

const BCORecommendations = ({ BcoRecommendationList }) => {
  const dispatch = useDispatch();

  const bcoRecommendationsColumn = [
    {
      field: "bcoRecommendationId",
      headerName: "BCO Recommendation ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "internalApplicationId",
      headerName: "Internal Application ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "applicationNumber",
      headerName: "Application Number",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "recommendedLoanAmount",
      headerName: "Recommended Loan Amount",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "emiValue",
      headerName: "EMI Value",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "tenureInMonths",
      headerName: "Tenure (In Months)",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "roi",
      headerName: "ROI",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "remarks",
      headerName: "Remarks",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              flex: 25,
            }}
          >
            <Tooltip title="View Remarks">
              <IconButton
                onClick={(e) => {
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogHeader(
                      "Remarks"
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogText(
                      params.row.remarks
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogOpen(true)
                  );
                }}
              >
                <Visibility sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "foirRemarks",
      headerName: "Foir Remarks",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              flex: 25,
            }}
          >
            <Tooltip title="View Foir Remarks">
              <IconButton
                onClick={(e) => {
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogHeader(
                      "Foir Remarks"
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogText(
                      params.row.foirRemarks
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogOpen(true)
                  );
                }}
              >
                <Visibility sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "businessRemarks",
      headerName: "Business Remarks",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: 25,
              flex: 1,
            }}
          >
            <Tooltip title="View Business Remarks">
              <IconButton
                onClick={(e) => {
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogHeader(
                      "Business Remarks"
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogText(
                      params.row.businessRemarks
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogOpen(true)
                  );
                }}
              >
                <Visibility sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "bureauRemarks",
      headerName: "Bureau Remarks",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: 25,
              flex: 1,
            }}
          >
            <Tooltip title="View Bureau Remarks">
              <IconButton
                onClick={(e) => {
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogHeader(
                      "Bureau Remarks"
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogText(
                      params.row.bureauRemarks
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogOpen(true)
                  );
                }}
              >
                <Visibility sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "collateralRemarks",
      headerName: "Collateral Remarks",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: 25,
              flex: 1,
            }}
          >
            <Tooltip title="View Collateral Remarks">
              <IconButton
                onClick={(e) => {
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogHeader(
                      "Collateral Remarks"
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogText(
                      params.row.collateralRemarks
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogOpen(true)
                  );
                }}
              >
                <Visibility sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "existingLoanRemarks",
      headerName: "Existing Loan Remarks",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: 25,
              flex: 1,
            }}
          >
            <Tooltip title="View Existing Loan Remarks">
              <IconButton
                onClick={(e) => {
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogHeader(
                      "Existing Loan Remarks"
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogText(
                      params.row.existingLoanRemarks
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogOpen(true)
                  );
                }}
              >
                <Visibility sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "overAllRemarks",
      headerName: "OverAll Remarks",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              justifyContent: "center",
              display: "flex",
              width: 25,
              flex: 1,
            }}
          >
            <Tooltip title="View OverAll Remarks">
              <IconButton
                onClick={(e) => {
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogHeader(
                      "OverAll Remarks"
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogText(
                      params.row.overAllRemarks
                    )
                  );
                  dispatch(
                    CommonInformationDialogReduerAction.updateDialogOpen(true)
                  );
                }}
              >
                <Visibility sx={{ color: "black" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "createdBy",
      headerName: "Created By",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "modifiedBy",
      headerName: "Modified By",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      valueGetter: (params) =>
        convertDateWithValidation(params.row.createdDate),
    },
    {
      field: "modifiedDate",
      headerName: "Modified Date",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
      valueGetter: (params) =>
        convertDateWithValidation(params.row.modifiedDate),
    },
  ];

  return (
    <AccordianContainer
      id="accord"
      title="BCO Recommendations"
      initialOpen={false}
    >
      <Box sx={{ marginTop: "-0.5%" }}>
        <CustomDataGrid
          noDataMessage="No Data"
          rows={
            validate(BcoRecommendationList)
              ? BcoRecommendationList.map((item, index) => ({
                  id: index + 1,
                  ...item,
                }))
              : []
          }
          columns={bcoRecommendationsColumn}
          pageSize={15}
          pageSizeOptions={[10]}
          gridLazyLoad={() => {}}
          gridHeight={305}
          getRowId={(row) => row.bcoRecommendationId}
          onCellKeyDown={(event, param) => {
            (param.key === "e" || param.key === "E") && param.preventDefault();
          }}
        />
      </Box>
    </AccordianContainer>
  );
};

export default BCORecommendations;
